import { useState, useEffect } from 'react';

export const useCountdown = (duration = 60, onEnd = () => {}, storageKey = 'countdown') => {
  const [countdown, setCountdown] = useState(() => {
    const lastTime = Number(localStorage.getItem(storageKey));
    const currentTime = new Date().getTime();
    if (lastTime && typeof lastTime === 'number') {
      let timeCount = Math.ceil((currentTime - lastTime) / 1000);
      if (timeCount >= 60) {
        return 0;
      } else {
        return 60 - timeCount;
      }
    }
    return 0;
  });
  const [isActive, setIsActive] = useState(countdown <= 0 ? false : true); // 初始化 isActive 为 false

  useEffect(() => {
    if (!isActive) return;
    let interval = setInterval(() => {
      if (countdown > 0) {
        setCountdown((prevCountdown) => prevCountdown - 1);
      } else {
        clearInterval(interval);
        onEnd && onEnd();
        setIsActive(false); // 倒计时结束时设置 isActive 为 false
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [isActive, countdown, storageKey]);

  const startCountdown = () => {
    if (countdown === 0) {
      setCountdown(duration); // 如果倒计时为0，则重置为初始时长
    }
    setIsActive(true); // 启动倒计时
    localStorage.setItem(storageKey, new Date().getTime());
  };

  const resetCountdown = () => {
    setIsActive(false); // 重置倒计时时设置 isActive 为 false
    setCountdown(duration);
  };

  return { countdown, isActive, startCountdown, resetCountdown };
};

export default useCountdown;
